var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "border" },
    [
      _c(
        "v-card",
        {
          class: { "grey darken-1": _vm.dragover },
          attrs: { elevation: "0" },
          on: {
            drop: function($event) {
              $event.preventDefault()
              return _vm.handleDrop($event)
            },
            dragover: function($event) {
              $event.preventDefault()
              _vm.dragover = true
            },
            dragenter: function($event) {
              $event.preventDefault()
              _vm.dragover = true
            },
            dragleave: function($event) {
              $event.preventDefault()
              _vm.dragover = false
            }
          }
        },
        [
          _c(
            "v-card-text",
            { staticClass: "d-flex flex-column align-center justify-center" },
            [
              _c("v-icon", {
                staticClass: "mt-5 primary--text",
                attrs: { size: "100" },
                domProps: { textContent: _vm._s("mdi-cloud-upload") }
              }),
              _vm._v(" "),
              _c("h3", { domProps: { textContent: _vm._s(_vm.subtitle) } })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }